import { Link } from "react-router-dom";

const columns = [
  {
    title: "影片导航",
    links: [
      { label: "最新电影", to: "/movies" },
      { label: "热播电视剧", to: "/tvshows" },
      { label: "影视资讯", to: "/news" },
      { label: "全部影片搜索", to: "/search" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "网站介绍", to: "/about" },
      { label: "内容说明", to: "/about" },
      { label: "联系我们", to: "/about" },
      { label: "版权声明", to: "/about" },
    ],
  },
];

const friendlyLinks = ["电影数据库", "剧集指南", "影视观察", "观影笔记", "幕后手记"];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 lg:pr-10">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-film-fill text-xl" />
              </span>
              <span className="text-xl font-bold tracking-wide text-background-50">四虎网站</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              四虎网站致力于为影迷汇聚高清电影与电视剧资源信息，提供影片介绍、分类检索与最新影视资讯，
              让每一次观影选择都更简单、更有乐趣。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-background-400">
              本站为影视信息展示平台，所有影片与资讯均为示例内容，不提供在线播放与下载功能。
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={`${col.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="whitespace-nowrap text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-primary-800 pt-6">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm text-background-400">
            <span className="text-background-300">友情链接：</span>
            {friendlyLinks.map((link) => (
              <span
                key={link}
                className="whitespace-nowrap rounded-md px-2 py-1 text-xs transition-colors hover:bg-primary-900 hover:text-accent-400"
              >
                {link}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 四虎网站 SI HU FILM. 保留所有权利。</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="whitespace-nowrap">高清影视 · 资讯速递 · 影迷社区</span>
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line" />
              内容均为示例演示
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}